import { useQuery } from '@apollo/react-hooks';
import { GET_REFEREE_REPORT_STATUS } from './GET_REFEREE_REPORT_STATUS.gql';
import { type GetRefereeFormStatus } from './types';

export const useQueryRefereeReportStatus = (
  formId: string,
): GetRefereeFormStatus => {
  const { data, loading, error } = useQuery(GET_REFEREE_REPORT_STATUS, {
    variables: {
      formId,
    },
    skip: !formId,
  });

  const status = data?.getRefereeFormStatus;

  return {
    status,
    loading,
    error,
  };
};
